import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'
import DealCloudLogo from './DealCloudLogo.vue'

export const dealCloudIntegration: PreviewIntegration = {
  id: 'dealcloud',
  name: 'DealCloud',
  description:
    'Sync your deal pipeline and relationship data from DealCloud for comprehensive AI context on financial operations.',
  icon: DealCloudLogo,
}
